"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7627],{

/***/ 69773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var BottomQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top rotate-180",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomQ);


/***/ }),

/***/ 29310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var TopQ = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlns: "http://www.w3.org/2000/svg",
        className: "case-studies__quote__icon case-studies__quote__icon--top",
        width: "10",
        height: "10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("symbol", {
                    id: "quote",
                    viewBox: "0 0 9 8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                        fillRule: "evenodd"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.155 7.9H0V4.699a4.715 4.715 0 0 1 .737-2.833A5.98 5.98 0 0 1 3.258.1l.945 1.7a4.584 4.584 0 0 0-1.568 1.029c-.278.344-.44.767-.463 1.209h1.983V7.9zM9 7.9H4.845V4.699a4.721 4.721 0 0 1 .736-2.833A5.99 5.99 0 0 1 8.103.1L9 1.8a4.58 4.58 0 0 0-1.52 1.029c-.278.344-.44.767-.463 1.209H9V7.9z",
                    fillRule: "evenodd"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TopQ);


/***/ }),

/***/ 67627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10990);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69773);
/* harmony import */ var src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29310);






var Img = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5076).then(__webpack_require__.bind(__webpack_require__, 15076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15076)
            ];
        }
    }
});
var ImgFifthSection = function(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ProjectScrubTl = gsap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].timeline */ .ZP.timeline({
            scrollTrigger: {
                trigger: "._caseFifthSectionTrigger",
                start: "`top 100%",
                scrub: 0.9
            }
        });
        ProjectScrubTl.to("._projectImg8", {
            y: -250,
            duration: 0.6
        }, "start");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "3xl:pb-[200px] relative _caseFifthSectionTrigger",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pt-[-50px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "bg-redblack pt-6 desktop:pb-6 pb-8 pl-5 xl:pl-6 3xl:w-[56.73611vw] w-[70vw] lg:w-[59.02778vw] lg:h-[40.98927vw] xl:h-[35.97222vw]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bgEverythingCaseStudyDesk h-full w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative 3xl:left-[7%] left-[7.5%] h-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center 3xl:max-w-[35rem] xl:max-w-[40rem] max-w-[26.56rem] h-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "bg-redblack 3xl:px-10 xl:pr-12 xl:pb-7 xl:pt-10 2xl:py-8 pl-8 pr-7 py-8 lg:py-4 text-white ",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mb-[28px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_TopQ__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    className: "font-bold text-white text-[1.57143rem] leading-[1.22727em] mb-3",
                                                    children: "These's a reason for everything"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "leading-[1.22727em] text-[1.28571rem] 3xl:text-[1.57143rem] 3xl:w-full lg:w-[80%]",
                                                    children: "Nothing less, nothing more. The focus with every design should be getting rid of the unnecessary. Every element should serve a purpose."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mt-[28px]",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_icons_Quote_BottomQ__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Img, {
                        href: "/case-study/10",
                        imgSrc: "/images/home/slider/10-wol.webp",
                        css: "w-[38.19444vw] h- -top-14 right-0 _projectImg8",
                        imgCss: "h-[38.19444vw]",
                        title: "NAACP",
                        desc: "UI/UX Design"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ImgFifthSection);


/***/ })

}]);